export const ANIMATION_CONFIG = {
    keyFrames: {
        mainHeader: {
            duration: 8.5,
            delay: 1.5,
        },
        secondaryHeader: {
            duration: 7,
            delay: 1,
        },
        cta: {
            duration: 5,
            delay: 1,
        }
    },
    text: {
        yOffset: -100,
        duration: 0.8,
        delay: 0,
        amount: 0.3,
    },
    gridBlock: {
        scale: 1.5,
        duration: 0.5,
        delay: 0,
        amount: 0.3,
    },
    projectImage: {
        duration: 0.5,
        amount: 0.1,
    },
    store: {
        duration: 0.7,
        scale: 1.2,
        amount: 0.1,
    },
    tag: {
        duration: 0.8,
        yOffset: -30,
        amount: 0.1,
    },
    scaleButton: {
        duration: 0.6,
        scale: 0.85,
        amount: 0.1,
    },
    developmentProcess: {
        duration: 0.3,
        yOffset: 20,
    },
    industriesImage: {
        duration: 0.5,
    },
    portfolioProjects: {
        duration: 0.3,
    },
    sliderProject: {
        amount: 0.1,
        duration: 0.8,
        scale: 1.2,
    },
    industryCard: {
        duration: 0.5,
        scale: 0.9,
        amount: 0.1,
    },
    yOffsetBlock: {
        yOffset: -100,
        duration: 0.5,
        amount: 0.3,
    },
    aboutUsSwiper: {
        amount: 0.1,
        duration: 0.5,
        scale: 0.5,
    },
    homeHeader: {
        topBlock: {
            yOffset: -100,
            xOffset: 100,
            duration: 0.8,
            delay: 0.5,
        },
        leftImage: {
            yOffset: -100,
            xOffset: -100,
            duration: 0.8,
            delay: 0.5,
        },
        rightImage: {
            yOffset: -100,
            xOffset: 100,
            duration: 0.8,
            delay: 0.5,

        },
        bottomLogo: {
            rotate: 45,
            duration: 0.8,
            delay: 0.5,
        },
    },
    portfolioHeader: {
        logo: {
            duration: 0.8,
            delay: 0,
        }
    },
    aboutUsHeader: {
        logo: {
            duration: 0.8,
            delay: 0,
        }
    }
}